export const newApiMap = {
  APIPreviewWorkItemAIValue: {
    m: 'post',
    u: [
      '/goapi/v5/project/auth/meego_ai/field/preview'
    ]
  },
  APIWorkItemSearch: {
    m: 'post',
    u: [
      '/goapi/v5/project/auth/meego_ai/common/work_item_search'
    ]
  },
  APIGetAIConfigSchema: {
    m: 'post',
    u: [
      '/goapi/v5/workitem/ai_config_schema/get'
    ]
  },
  APIGetAIEntitySchema: {
    m: 'post',
    u: [
      '/goapi/v5/workitem/ai_entity_schema/get'
    ]
  },
  APICreateAIApplication: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/create'
    ]
  },
  APIUpdateAIApplication: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/update'
    ]
  },
  APIBatchQueryAIApplication: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/batch_query'
    ]
  },
  APIBatchDeleteAIApplication: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/batch_delete'
    ]
  },
  APIAIApplicationPreview: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/preview'
    ]
  },
  APIQueryTemplateDetailByUUID: {
    m: 'post',
    u: [
      '/goapi/v1/projects/:project_key/templates/detail'
    ]
  },
  APIQueryTemplateDetailByUUIDAndVersion: {
    m: 'get',
    u: [
      '/goapi/v2/projects/:project_key/templates/version'
    ],
    q: [
      'template_uuid',
      'version'
    ]
  },
  APICreateAIApplicationGroup: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application_group/create'
    ]
  },
  APIUpdateAIApplicationGroup: {
    m: 'put',
    u: [
      '/goapi/v5/ai_application_group/update'
    ]
  },
  APIListAIApplicationGroup: {
    m: 'get',
    u: [
      '/goapi/v5/ai_application_group/list'
    ],
    q: [
      'page',
      'page_size',
      'madmin_ai_application_group_name',
      'name'
    ]
  }
};